import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Audio({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M38.0181 24.022C38.0181 27.6538 36.5754 31.1368 34.0073 33.7049C31.4392 36.273 27.9562 37.7157 24.3244 37.7157C20.6926 37.7157 17.2095 36.273 14.6414 33.7049C12.0733 31.1368 10.6306 27.6538 10.6306 24.022"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.978 24.0221C15.9558 25.1384 16.1565 26.248 16.5683 27.2858C16.9802 28.3236 17.5949 29.2689 18.3766 30.0662C19.1582 30.8635 20.0911 31.497 21.1205 31.9294C22.1499 32.3618 23.2553 32.5845 24.3718 32.5845C25.4884 32.5845 26.5937 32.3618 27.6232 31.9294C28.6526 31.497 29.5855 30.8635 30.3671 30.0662C31.1487 29.2689 31.7635 28.3236 32.1753 27.2858C32.5872 26.248 32.7879 25.1384 32.7657 24.0221V12.5625C32.7879 11.4461 32.5872 10.3366 32.1753 9.29873C31.7635 8.2609 31.1487 7.31565 30.3671 6.51831C29.5855 5.72097 28.6526 5.08755 27.6232 4.65514C26.5937 4.22273 25.4884 4 24.3718 4C23.2553 4 22.1499 4.22273 21.1205 4.65514C20.0911 5.08755 19.1582 5.72097 18.3766 6.51831C17.5949 7.31565 16.9802 8.2609 16.5683 9.29873C16.1565 10.3366 15.9558 11.4461 15.978 12.5625V24.0221Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.324 37.7393V44.0002"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5755 44H13.0779"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Dataset({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M23.75 20.4C32.4485 20.4 39.5 17.1765 39.5 13.2C39.5 9.22355 32.4485 6 23.75 6C15.0515 6 8 9.22355 8 13.2C8 17.1765 15.0515 20.4 23.75 20.4Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5039 13.2002V20.4002C39.5039 24.3752 32.4539 27.6002 23.7539 27.6002C15.0539 27.6002 8.00391 24.3752 8.00391 20.4002V13.2002"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5039 20.3999V27.5999C39.5039 31.5749 32.4539 34.7999 23.7539 34.7999C15.0539 34.7999 8.00391 31.5749 8.00391 27.5999V20.3999"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5039 27.6001V34.8001C39.5039 38.7751 32.4539 42.0001 23.7539 42.0001C15.0539 42.0001 8.00391 38.7751 8.00391 34.8001V27.6001"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Date({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M37.5 8.25H10.5C8.01472 8.25 6 10.2647 6 12.75V37.5C6 39.9853 8.01472 42 10.5 42H37.5C39.9853 42 42 39.9853 42 37.5V12.75C42 10.2647 39.9853 8.25 37.5 8.25Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2344 6V10.5"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.875 6V10.5"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5156 6V10.5"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1543 6V10.5"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5957 6V10.5"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.429 20.358C16.9086 20.358 18.108 19.1586 18.108 17.679C18.108 16.1994 16.9086 15 15.429 15C13.9494 15 12.75 16.1994 12.75 17.679C12.75 19.1586 13.9494 20.358 15.429 20.358Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9993 37.5001C25.4789 37.5001 26.6783 36.3007 26.6783 34.8211C26.6783 33.3415 25.4789 32.1421 23.9993 32.1421C22.5197 32.1421 21.3203 33.3415 21.3203 34.8211C21.3203 36.3007 22.5197 37.5001 23.9993 37.5001Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.429 37.5001C16.9086 37.5001 18.108 36.3007 18.108 34.8211C18.108 33.3415 16.9086 32.1421 15.429 32.1421C13.9494 32.1421 12.75 33.3415 12.75 34.8211C12.75 36.3007 13.9494 37.5001 15.429 37.5001Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5716 28.9288C34.0511 28.9288 35.2506 27.7294 35.2506 26.2498C35.2506 24.7702 34.0511 23.5708 32.5716 23.5708C31.092 23.5708 29.8926 24.7702 29.8926 26.2498C29.8926 27.7294 31.092 28.9288 32.5716 28.9288Z"
        fill={stroke ?? '#141A21'}
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M23.9993 28.9288C25.4789 28.9288 26.6783 27.7294 26.6783 26.2498C26.6783 24.7702 25.4789 23.5708 23.9993 23.5708C22.5197 23.5708 21.3203 24.7702 21.3203 26.2498C21.3203 27.7294 22.5197 28.9288 23.9993 28.9288Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.429 28.929C16.9086 28.929 18.108 27.7296 18.108 26.25C18.108 24.7705 16.9086 23.571 15.429 23.571C13.9494 23.571 12.75 24.7705 12.75 26.25C12.75 27.7296 13.9494 28.929 15.429 28.929Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9993 20.358C25.4789 20.358 26.6783 19.1586 26.6783 17.679C26.6783 16.1994 25.4789 15 23.9993 15C22.5197 15 21.3203 16.1994 21.3203 17.679C21.3203 19.1586 22.5197 20.358 23.9993 20.358Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5716 20.358C34.0511 20.358 35.2506 19.1586 35.2506 17.679C35.2506 16.1994 34.0511 15 32.5716 15C31.092 15 29.8926 16.1994 29.8926 17.679C29.8926 19.1586 31.092 20.358 32.5716 20.358Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function File({ size, fileExtension, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M38 17.89V44H10V4H28.3333M28.3333 4L38 13.1667H28.3333V4Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {fileExtension && (
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          fill="black"
          fontSize="8"
          dy=".3em"
          fontWeight="extraBold"
        >
          {fileExtension}
        </text>
      )}
    </SvgIconComponent>
  )
}

export function Folder({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M25.2044 10.5014L23.3434 8.44775C23.2168 8.30782 23.0624 8.19575 22.8902 8.11867C22.7179 8.04159 22.5315 8.00117 22.3428 8H5.36077C4.99987 8 4.65375 8.14337 4.39856 8.39856C4.14337 8.65375 4 8.99987 4 9.36077V34.9577C4 34.9577 4 38.0194 6.72153 38.0194H6.83409H42.7068C42.9934 38.0195 43.2727 37.9291 43.505 37.7611C43.7372 37.5932 43.9104 37.3561 44 37.0839V15.3366C44 14.9757 43.8566 14.6296 43.6014 14.3744C43.3463 14.1192 43.0001 13.9759 42.6392 13.9759H9.5181C9.15874 13.9765 8.81428 14.1196 8.56017 14.3737C8.30605 14.6278 8.163 14.9723 8.16234 15.3316V33.4068"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </SvgIconComponent>
  )
}

export function GroupStatic({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M10.6191 32.1487H16.5459V38.0754"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9141 17.334H28.0262"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9141 21.7778H22.4701"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9141 26.2222H20.1169"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5469 9.92672H28.3981V6.96336H25.437V4H19.5103V6.96336H16.5469V9.92672Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4704 38.0755H16.5459L10.6191 32.1486V8.44385H16.5459"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3965 8.44385H34.3233V18.4898"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.1814 29.1716C38.2262 28.845 38.2485 28.5158 38.2482 28.1861C38.2482 26.0936 37.4169 24.0868 35.9373 22.6072C34.4577 21.1276 32.4509 20.2964 30.3585 20.2964C28.266 20.2964 26.2592 21.1276 24.7796 22.6072C23.3 24.0868 22.4688 26.0936 22.4688 28.1861C22.4684 28.5158 22.4907 28.845 22.5355 29.1716C23.2125 35.7983 30.3642 44 30.3642 44C30.3642 44 37.5067 35.8006 38.1814 29.1716Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
      />
      <path
        d="M38.1814 29.1716C38.2262 28.845 38.2485 28.5158 38.2482 28.1861C38.2482 26.0936 37.4169 24.0868 35.9373 22.6072C34.4577 21.1276 32.4509 20.2964 30.3585 20.2964C28.266 20.2964 26.2592 21.1276 24.7796 22.6072C23.3 24.0868 22.4688 26.0936 22.4688 28.1861C22.4684 28.5158 22.4907 28.845 22.5355 29.1716C23.2125 35.7983 30.3642 44 30.3642 44C30.3642 44 37.5067 35.8006 38.1814 29.1716Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3587 31.5733C32.2255 31.5733 33.7388 30.0599 33.7388 28.1931C33.7388 26.3263 32.2255 24.813 30.3587 24.813C28.4919 24.813 26.9785 26.3263 26.9785 28.1931C26.9785 30.0599 28.4919 31.5733 30.3587 31.5733Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function GroupFilter({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M10 32.1472H15.9252V38.0725"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9258 9.92531H27.7763V6.96265H24.8136V4H18.8884V6.96265H15.9258V9.92531Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9252 8.44385H10V32.1471L15.9252 38.0724H21.8505"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.7773 8.44385H33.7026V22.8165"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2188 44.0002V34.7554"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M29.8477 44V41.3921"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M35.4473 44.0003V33.4526"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M24.2188 34.1619C25.5272 34.1619 26.5879 33.1012 26.5879 31.7928C26.5879 30.4843 25.5272 29.4236 24.2188 29.4236C22.9103 29.4236 21.8496 30.4843 21.8496 31.7928C21.8496 33.1012 22.9103 34.1619 24.2188 34.1619Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M29.8477 40.7989C31.1561 40.7989 32.2169 39.7382 32.2169 38.4297C32.2169 37.1213 31.1561 36.0605 29.8477 36.0605C28.5392 36.0605 27.4785 37.1213 27.4785 38.4297C27.4785 39.7382 28.5392 40.7989 29.8477 40.7989Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M35.4453 32.8589C36.7538 32.8589 37.8145 31.7982 37.8145 30.4898C37.8145 29.1813 36.7538 28.1206 35.4453 28.1206C34.1369 28.1206 33.0762 29.1813 33.0762 30.4898C33.0762 31.7982 34.1369 32.8589 35.4453 32.8589Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M24.2188 28.8325V26.2246"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M29.8477 35.467V26.2222"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M35.4473 27.5274V26.2246"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M16.3457 17.332H27.4567"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3457 21.7778H27.4567"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3457 26.2222H20.4187"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Link({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M22.0206 25.9798C20.8205 24.7792 20.1465 23.1512 20.1465 21.4536C20.1465 19.7561 20.8205 18.1281 22.0206 16.9275L31.073 7.87507C31.6674 7.2806 32.3729 6.80907 33.1495 6.48734C33.9261 6.16561 34.7584 6 35.599 6C36.4396 6 37.2721 6.16561 38.0487 6.48734C38.8253 6.80907 39.5309 7.2806 40.1252 7.87507C40.7197 8.46941 41.1913 9.17503 41.513 9.95164C41.8347 10.7283 42.0004 11.5606 42.0004 12.4012C42.0004 13.2418 41.8347 14.0743 41.513 14.8509C41.1913 15.6275 40.7197 16.3331 40.1252 16.9275L31.073 25.9798"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9798 20.8872C27.1799 22.0878 27.8539 23.7158 27.8539 25.4134C27.8539 27.1109 27.1799 28.7389 25.9798 29.9395L16.9273 38.9919C16.333 39.5864 15.6274 40.0579 14.8508 40.3797C14.0742 40.7014 13.242 40.867 12.4014 40.867C11.5608 40.867 10.7283 40.7014 9.95164 40.3797C9.17503 40.0579 8.46947 39.5864 7.87513 38.9919C7.28067 38.3976 6.80907 37.692 6.48734 36.9154C6.16561 36.1388 6 35.3064 6 34.4658C6 33.6252 6.16561 32.7927 6.48734 32.0161C6.80907 31.2395 7.28067 30.5339 7.87513 29.9395L16.9273 20.8872"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Photo({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M5.18573 36.1869V17.1217C5.18077 16.6232 5.27426 16.1287 5.46083 15.6664C5.6474 15.2041 5.92339 14.7832 6.27297 14.4278C6.62255 14.0723 7.03884 13.7894 7.49799 13.5953C7.95713 13.4011 8.45009 13.2994 8.9486 13.2961H39.0515C39.5489 13.2994 40.0409 13.4007 40.4992 13.5941C40.9575 13.7875 41.3732 14.0692 41.7226 14.4233C42.0721 14.7774 42.3483 15.1968 42.5356 15.6577C42.7229 16.1185 42.8177 16.6117 42.8143 17.1092V36.1869C42.8177 36.6843 42.7229 37.1775 42.5356 37.6384C42.3483 38.0992 42.0721 38.5187 41.7226 38.8727C41.3732 39.2268 40.9575 39.5086 40.4992 39.702C40.0409 39.8954 39.5489 39.9966 39.0515 39.9999H8.9486C8.45115 39.9966 7.95923 39.8954 7.50091 39.702C7.04259 39.5086 6.62685 39.2268 6.27744 38.8727C5.92802 38.5187 5.65177 38.0992 5.46445 37.6384C5.27714 37.1775 5.18243 36.6843 5.18573 36.1869Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.056 13.2994H16.9453L18.3093 9.22293C18.423 8.86928 18.6456 8.5606 18.9452 8.34097C19.2447 8.12134 19.6061 8.00201 19.9775 8H28.0207C28.392 8.00248 28.7531 8.122 29.0526 8.34156C29.3521 8.56112 29.5748 8.86953 29.6889 9.22293L31.056 13.2994Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0007 34.0609C27.8972 34.0609 31.056 30.9021 31.056 27.0056C31.056 23.109 27.8972 19.9502 24.0007 19.9502C20.1041 19.9502 16.9453 23.109 16.9453 27.0056C16.9453 30.9021 20.1041 34.0609 24.0007 34.0609Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4766 21.6499V32.2329"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3709 21.0479C36.3459 21.0479 37.1363 20.2575 37.1363 19.2825C37.1363 18.3075 36.3459 17.5171 35.3709 17.5171C34.3959 17.5171 33.6055 18.3075 33.6055 19.2825C33.6055 20.2575 34.3959 21.0479 35.3709 21.0479Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function PlanSimple({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M36.7554 12.8366H6V38.468H36.7554C37.4384 38.4837 38.1177 38.36 38.7532 38.1095C39.3888 37.8589 39.9679 37.4839 40.4565 37.0064C40.9451 36.5289 41.3333 35.9586 41.5984 35.3289C41.8635 34.6993 42 34.023 42 33.3398C42 32.6566 41.8635 31.9804 41.5984 31.3507C41.3333 30.721 40.9451 30.1507 40.4565 29.6732C39.9679 29.1957 39.3888 28.8207 38.7532 28.5702C38.1177 28.3196 37.4384 28.1987 36.7554 28.2144V12.8366ZM36.7554 12.8366V6.0027C38.114 6.00627 39.416 6.54486 40.3767 7.50555C41.3374 8.46624 41.8787 9.76819 41.8822 11.1268V33.3412"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2948 29.5129C38.0057 30.6078 37.3632 31.5767 36.4669 32.2689C35.5707 32.9612 34.4709 33.3381 33.3385 33.3411H11.1268V17.9634H36.3821"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Plan({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M36.7554 12.8339H6V38.4653H36.7554C37.4384 38.481 38.1177 38.3573 38.7532 38.1068C39.3888 37.8562 39.9679 37.4812 40.4565 37.0037C40.9451 36.5262 41.3333 35.9559 41.5984 35.3262C41.8635 34.6966 42 34.0203 42 33.3371M36.7554 12.8339V28.2117C37.4384 28.196 38.1177 28.3169 38.7532 28.5675C39.3888 28.818 39.9679 29.193 40.4565 29.6705C40.9451 30.148 41.3333 30.7183 41.5984 31.348C41.8635 31.9777 42 32.6539 42 33.3371M36.7554 12.8339V6C38.114 6.00357 39.416 6.54216 40.3767 7.50285C41.3374 8.46354 41.9959 9.76548 41.9995 11.1241L42 33.3371"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2948 29.5102C38.0057 30.6052 37.3631 31.574 36.4669 32.2662C35.5706 32.9585 34.4709 33.3354 33.3384 33.3384H11.1267V17.9607H36.382"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1267 23.0876H23.0875V33.3386"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9218 17.9609V28.2118H23.0879"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ProjectInverted({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 40.9667H44V25.0196H34.5543C33.9469 25.0196 33.4554 24.5295 33.4554 23.9207C33.4554 23.3142 33.9469 22.8218 34.5543 22.8218H44V13.0326H4V22.7821H13.4751C14.0817 22.7821 14.574 23.2723 14.574 23.881C14.574 24.488 14.0817 24.9798 13.4751 24.9798H4V40.9667ZM18.1523 10.8349H29.8695V8.90107C29.8695 8.40422 29.4539 8 28.9466 8H19.0566C18.5659 8 18.1523 8.41315 18.1523 8.90107V10.8349ZM27.9568 28.9448H20.0442C19.4347 28.9448 18.9453 28.4545 18.9453 27.8459V19.9339C18.9453 19.325 19.4347 18.835 20.0442 18.835H27.9568C28.5649 18.835 29.0557 19.325 29.0557 19.9339V27.8459C29.0557 28.4545 28.5649 28.9448 27.9568 28.9448ZM21.1444 26.7471H26.8592V21.0329H21.1444V26.7471Z"
        fill="#141A21"
      />
    </SvgIconComponent>
  )
}

export function Project({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M43.2007 12.572H4.80078V40H43.2007V12.572Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6055 23.4878H43.2055"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.82214 23.4507H14.4221"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.674 12.48V9.82804C17.674 9.58787 17.7213 9.35004 17.8132 9.12817C17.9052 8.9063 18.0399 8.70468 18.2098 8.53491C18.3797 8.36515 18.5814 8.23054 18.8033 8.13875C19.0253 8.04697 19.2631 7.99983 19.5033 8H28.4993C28.7394 7.99983 28.9773 8.04697 29.1992 8.13875C29.4212 8.23054 29.6228 8.36515 29.7927 8.53491C29.9626 8.70468 30.0974 8.9063 30.1893 9.12817C30.2813 9.35004 30.3286 9.58787 30.3286 9.82804V12.48"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6004 19.8521H20.4004V27.052H27.6004V19.8521Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Report({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M31 8H39V44H17M17 44V36H9M17 44L9 36M9 36V8H17M21 6V4H27V6H31V10H17V6H21Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 26H18L22 18L26 36L30 26H32"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Sketch({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M6 10.7112C14.1818 4.16576 19.0691 10.7112 15.8182 17.2567C12.5673 23.8021 3.17182 37.043 10.9091 40.1358C19.0909 43.4085 21.9545 31.0621 27.2727 20.513C32.1818 10.6949 40.3418 17.2539 37.0909 25.4221C35.25 29.9685 27.2727 46.6948 42 38.4912"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </SvgIconComponent>
  )
}

export function TaskStack({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M6.2592 13.8594H6.1424C5.5742 13.8594 5.02927 14.0851 4.6275 14.4869C4.22572 14.8886 4 15.4336 4 16.0018V36.4482C4 37.0164 4.22572 37.5613 4.6275 37.9631C5.02927 38.3649 5.5742 38.5906 6.1424 38.5906H38C38.5682 38.5906 39.1131 38.3649 39.5149 37.9631C39.9167 37.5613 40.1424 37.0164 40.1424 36.4482V36.3314"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M40.8002 10H11.0594C9.29206 10 7.85938 11.4327 7.85938 13.2V31.5296C7.85938 33.2969 9.29206 34.7296 11.0594 34.7296H40.8002C42.5675 34.7296 44.0002 33.2969 44.0002 31.5296V13.2C44.0002 11.4327 42.5675 10 40.8002 10Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M12.9526 21.434C12.9526 20.9487 13.046 20.496 13.2326 20.076C13.4193 19.656 13.6713 19.292 13.9886 18.984C14.3153 18.676 14.698 18.4333 15.1366 18.256C15.5753 18.0787 16.0466 17.99 16.5506 17.99C17.1013 17.99 17.6006 18.0927 18.0486 18.298C18.4966 18.494 18.8746 18.7833 19.1826 19.166C19.5 19.5393 19.7426 19.9967 19.9106 20.538C20.088 21.0793 20.1766 21.6953 20.1766 22.386C20.1766 23.338 20.088 24.1733 19.9106 24.892C19.7333 25.6013 19.4766 26.1987 19.1406 26.684C18.814 27.1693 18.4173 27.5333 17.9506 27.776C17.484 28.0187 16.966 28.14 16.3966 28.14C15.7526 28.14 15.1646 27.9953 14.6326 27.706C14.11 27.4073 13.6853 26.992 13.3586 26.46L14.2686 25.508C14.4833 25.9 14.782 26.2127 15.1646 26.446C15.5473 26.67 15.9626 26.782 16.4106 26.782C17.1106 26.782 17.6706 26.488 18.0906 25.9C18.5106 25.312 18.7253 24.4813 18.7346 23.408C18.5386 23.828 18.2306 24.1593 17.8106 24.402C17.4 24.6447 16.9286 24.766 16.3966 24.766C15.9113 24.766 15.4586 24.682 15.0386 24.514C14.6186 24.3367 14.2546 24.0987 13.9466 23.8C13.6386 23.5013 13.396 23.1513 13.2186 22.75C13.0413 22.3393 12.9526 21.9007 12.9526 21.434ZM16.5366 19.292C16.2473 19.292 15.9766 19.348 15.7246 19.46C15.4726 19.572 15.2486 19.726 15.0526 19.922C14.866 20.118 14.7166 20.3467 14.6046 20.608C14.4926 20.86 14.4366 21.1307 14.4366 21.42C14.4366 21.7093 14.4926 21.98 14.6046 22.232C14.7166 22.484 14.866 22.708 15.0526 22.904C15.2486 23.0907 15.4726 23.24 15.7246 23.352C15.986 23.464 16.2613 23.52 16.5506 23.52C16.84 23.52 17.1106 23.464 17.3626 23.352C17.624 23.24 17.848 23.0907 18.0346 22.904C18.2306 22.7173 18.3846 22.498 18.4966 22.246C18.6086 21.9847 18.6646 21.714 18.6646 21.434C18.6646 21.1447 18.6086 20.8693 18.4966 20.608C18.3846 20.3467 18.2306 20.118 18.0346 19.922C17.8386 19.726 17.61 19.572 17.3486 19.46C17.0966 19.348 16.826 19.292 16.5366 19.292ZM21.8429 21.434C21.8429 20.9487 21.9362 20.496 22.1229 20.076C22.3095 19.656 22.5615 19.292 22.8789 18.984C23.2055 18.676 23.5882 18.4333 24.0269 18.256C24.4655 18.0787 24.9369 17.99 25.4409 17.99C25.9915 17.99 26.4909 18.0927 26.9389 18.298C27.3869 18.494 27.7649 18.7833 28.0729 19.166C28.3902 19.5393 28.6329 19.9967 28.8009 20.538C28.9782 21.0793 29.0669 21.6953 29.0669 22.386C29.0669 23.338 28.9782 24.1733 28.8009 24.892C28.6236 25.6013 28.3669 26.1987 28.0309 26.684C27.7042 27.1693 27.3075 27.5333 26.8409 27.776C26.3742 28.0187 25.8562 28.14 25.2869 28.14C24.6429 28.14 24.0549 27.9953 23.5229 27.706C23.0002 27.4073 22.5755 26.992 22.2489 26.46L23.1589 25.508C23.3735 25.9 23.6722 26.2127 24.0549 26.446C24.4375 26.67 24.8529 26.782 25.3009 26.782C26.0009 26.782 26.5609 26.488 26.9809 25.9C27.4009 25.312 27.6155 24.4813 27.6249 23.408C27.4289 23.828 27.1209 24.1593 26.7009 24.402C26.2902 24.6447 25.8189 24.766 25.2869 24.766C24.8015 24.766 24.3489 24.682 23.9289 24.514C23.5089 24.3367 23.1449 24.0987 22.8369 23.8C22.5289 23.5013 22.2862 23.1513 22.1089 22.75C21.9315 22.3393 21.8429 21.9007 21.8429 21.434ZM25.4269 19.292C25.1375 19.292 24.8669 19.348 24.6149 19.46C24.3629 19.572 24.1389 19.726 23.9429 19.922C23.7562 20.118 23.6069 20.3467 23.4949 20.608C23.3829 20.86 23.3269 21.1307 23.3269 21.42C23.3269 21.7093 23.3829 21.98 23.4949 22.232C23.6069 22.484 23.7562 22.708 23.9429 22.904C24.1389 23.0907 24.3629 23.24 24.6149 23.352C24.8762 23.464 25.1515 23.52 25.4409 23.52C25.7302 23.52 26.0009 23.464 26.2529 23.352C26.5142 23.24 26.7382 23.0907 26.9249 22.904C27.1209 22.7173 27.2749 22.498 27.3869 22.246C27.4989 21.9847 27.5549 21.714 27.5549 21.434C27.5549 21.1447 27.4989 20.8693 27.3869 20.608C27.2749 20.3467 27.1209 20.118 26.9249 19.922C26.7289 19.726 26.5002 19.572 26.2389 19.46C25.9869 19.348 25.7162 19.292 25.4269 19.292ZM30.7331 21.434C30.7331 20.9487 30.8265 20.496 31.0131 20.076C31.1998 19.656 31.4518 19.292 31.7691 18.984C32.0958 18.676 32.4785 18.4333 32.9171 18.256C33.3558 18.0787 33.8271 17.99 34.3311 17.99C34.8818 17.99 35.3811 18.0927 35.8291 18.298C36.2771 18.494 36.6551 18.7833 36.9631 19.166C37.2805 19.5393 37.5231 19.9967 37.6911 20.538C37.8685 21.0793 37.9571 21.6953 37.9571 22.386C37.9571 23.338 37.8685 24.1733 37.6911 24.892C37.5138 25.6013 37.2571 26.1987 36.9211 26.684C36.5945 27.1693 36.1978 27.5333 35.7311 27.776C35.2645 28.0187 34.7465 28.14 34.1771 28.14C33.5331 28.14 32.9451 27.9953 32.4131 27.706C31.8905 27.4073 31.4658 26.992 31.1391 26.46L32.0491 25.508C32.2638 25.9 32.5625 26.2127 32.9451 26.446C33.3278 26.67 33.7431 26.782 34.1911 26.782C34.8911 26.782 35.4511 26.488 35.8711 25.9C36.2911 25.312 36.5058 24.4813 36.5151 23.408C36.3191 23.828 36.0111 24.1593 35.5911 24.402C35.1805 24.6447 34.7091 24.766 34.1771 24.766C33.6918 24.766 33.2391 24.682 32.8191 24.514C32.3991 24.3367 32.0351 24.0987 31.7271 23.8C31.4191 23.5013 31.1765 23.1513 30.9991 22.75C30.8218 22.3393 30.7331 21.9007 30.7331 21.434ZM34.3171 19.292C34.0278 19.292 33.7571 19.348 33.5051 19.46C33.2531 19.572 33.0291 19.726 32.8331 19.922C32.6465 20.118 32.4971 20.3467 32.3851 20.608C32.2731 20.86 32.2171 21.1307 32.2171 21.42C32.2171 21.7093 32.2731 21.98 32.3851 22.232C32.4971 22.484 32.6465 22.708 32.8331 22.904C33.0291 23.0907 33.2531 23.24 33.5051 23.352C33.7665 23.464 34.0418 23.52 34.3311 23.52C34.6205 23.52 34.8911 23.464 35.1431 23.352C35.4045 23.24 35.6285 23.0907 35.8151 22.904C36.0111 22.7173 36.1651 22.498 36.2771 22.246C36.3891 21.9847 36.4451 21.714 36.4451 21.434C36.4451 21.1447 36.3891 20.8693 36.2771 20.608C36.1651 20.3467 36.0111 20.118 35.8151 19.922C35.6191 19.726 35.3905 19.572 35.1291 19.46C34.8771 19.348 34.6065 19.292 34.3171 19.292Z"
        fill="#141A21"
      />
    </SvgIconComponent>
  )
}

export function Task({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M14.6933 24.1733L21.0735 30.6667L33.5833 18.27"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TemplateExcel({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M21.1045 41.7425L7.10519 34.2276C6.76325 34.0351 6.47989 33.7535 6.28535 33.4128C6.0908 33.072 5.99236 32.6849 6.00046 32.2926V15.6428C5.99481 15.2528 6.09443 14.8685 6.28885 14.5303C6.48327 14.1922 6.76529 13.9127 7.10519 13.7213L21.1045 6.20645C21.4201 6.0513 21.7707 5.98154 22.1216 6.00417C22.4725 6.0268 22.8113 6.14103 23.1043 6.33544C23.3973 6.52985 23.6341 6.79765 23.7913 7.11216C23.9486 7.42667 24.0206 7.77692 24.0002 8.12794V39.8255C24.0197 40.1762 23.9471 40.5258 23.7896 40.8397C23.632 41.1535 23.395 41.4207 23.1022 41.6145C22.8093 41.8084 22.4709 41.9222 22.1204 41.9447C21.7699 41.9671 21.4197 41.8974 21.1045 41.7425Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 10.468H39.9998C40.2624 10.468 40.5225 10.5198 40.7652 10.6203C41.0079 10.7208 41.2284 10.8681 41.4142 11.0539C41.5999 11.2396 41.7473 11.4601 41.8478 11.7028C41.9483 11.9455 42 12.2056 42 12.4683V35.4674C42 35.7301 41.9483 35.9902 41.8478 36.2329C41.7473 36.4756 41.5999 36.6961 41.4142 36.8818C41.2284 37.0676 41.0079 37.2149 40.7652 37.3154C40.5225 37.4159 40.2624 37.4677 39.9998 37.4677H24.0002"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 17.9673H37.5007"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M31.5 23.968H37.5007"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M31.5 29.9663H37.5007"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 17.9673H30.0009"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 23.968H30.0009"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 29.9663H30.0009"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 19.4658L17.8124 29.5907"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8124 18.3408L12.1875 28.4634"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TemplateWord({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M21.1045 41.7425L7.10519 34.2276C6.76325 34.0351 6.47989 33.7535 6.28535 33.4128C6.0908 33.072 5.99236 32.6849 6.00046 32.2926V15.6428C5.99481 15.2528 6.09443 14.8685 6.28885 14.5303C6.48327 14.1922 6.76529 13.9127 7.10519 13.7213L21.1045 6.20645C21.4201 6.0513 21.7707 5.98154 22.1216 6.00417C22.4725 6.0268 22.8113 6.14103 23.1043 6.33544C23.3973 6.52985 23.6341 6.79765 23.7913 7.11216C23.9486 7.42667 24.0206 7.77692 24.0002 8.12794V39.8255C24.0197 40.1762 23.9471 40.5258 23.7896 40.8397C23.632 41.1535 23.395 41.4207 23.1022 41.6145C22.8093 41.8084 22.4709 41.9222 22.1204 41.9447C21.7699 41.9671 21.4197 41.8974 21.1045 41.7425Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 10.468H39.9998C40.2624 10.468 40.5225 10.5198 40.7652 10.6203C41.0079 10.7208 41.2284 10.8681 41.4142 11.0539C41.5999 11.2396 41.7473 11.4601 41.8478 11.7028C41.9483 11.9455 42 12.2056 42 12.4683V35.4674C42 35.7301 41.9483 35.9902 41.8478 36.2329C41.7473 36.4756 41.5999 36.6961 41.4142 36.8818C41.2284 37.0676 41.0079 37.2149 40.7652 37.3154C40.5225 37.4159 40.2624 37.4677 39.9998 37.4677H24.0002"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 17.9673H37.5001"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 23.968H37.5001"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 29.9663H37.5001"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5686 18.2534L16.6595 29.6801L14.337 19.6816L12.1024 28.13L10.4336 20.5814"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function AddToReport({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M6 24.0269H24"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M17.7578 17.25L23.5853 23.0775C23.8498 23.3432 23.9983 23.7028 23.9983 24.0776C23.9983 24.4525 23.8498 24.8121 23.5853 25.0778L17.9176 30.75"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M32.5501 9.60001H39.75V42H19.9499M19.9499 42V34.8H12.75M19.9499 42L12.75 34.8M12.75 19.5V9.60001H19.9499M12.75 34.8V28.5M23.5501 7.79997V6H28.9499V7.79997H32.5501V11.4H19.9499V7.79997H23.5501Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ImportPlan({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M36.3105 29.7856V41.1609"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        className="special-color"
      />
      <path
        d="M30.625 35.4719H42.0003"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        className="special-color"
      />
      <path
        d="M25.6987 35.4747H6V13.7747H32.0373V26.7948M36.3773 12.3289V25.045M32.0373 13.7858V8C33.1884 8 34.2922 8.45724 35.1061 9.27115C35.9201 10.0851 36.3773 11.189 36.3773 12.34"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.1295 31.1349H10.332V18.1147H31.7087"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.332 22.4546H20.4578V31.1347"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2455 18.1147V26.7948H20.457"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function NewFolder({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M37.6836 26.9526V33.2702V39.5877"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        className="special-color"
      />
      <path
        d="M31.3652 33.2703H44.0003"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        className="special-color"
      />
      <path
        d="M21.847 10.1059L20.2786 8.37732C20.1714 8.25958 20.0411 8.16528 19.8958 8.10035C19.7504 8.03542 19.5933 8.00123 19.4341 8H5.14506C4.84137 8 4.55012 8.12065 4.33538 8.33538C4.12065 8.55012 4 8.84137 4 9.14506V30.6992C4 30.6992 4.00003 33.2767 6.29232 33.2767H25.0606"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M37.6824 20.6374V14.1707C37.6824 14.0201 37.6528 13.8711 37.5951 13.732C37.5374 13.5929 37.4529 13.4666 37.3463 13.3603C37.2398 13.2539 37.1132 13.1696 36.9741 13.1122C36.8349 13.0548 36.6858 13.0253 36.5352 13.0256H8.635C8.33248 13.0256 8.04239 13.1458 7.82848 13.3597C7.61456 13.5737 7.49436 13.8638 7.49436 14.1663V29.3876"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </SvgIconComponent>
  )
}

export function NewProject({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M36.6855 28.2612V39.9998"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        className="special-color"
      />
      <path
        d="M30.8164 34.1306H42.555"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        className="special-color"
      />
      <path
        d="M25.808 34.0566H5.40039V11.7151H36.6808V23.5504"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8613 20.5933H36.6803"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41388 20.5864H13.2329"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8828 11.6475V9.48866C15.8828 9.09383 16.0397 8.71524 16.3189 8.43606C16.5981 8.15687 16.9766 8 17.3715 8H24.698C25.0929 8 25.4715 8.15687 25.7506 8.43606C26.0298 8.71524 26.1867 9.09383 26.1867 9.48866V11.6475"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9683 17.6519H18.1035V23.5167H23.9683V17.6519Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TemplateNew({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M18.3943 37.3266L6.9059 31.1592C6.62546 31.0011 6.39311 30.7699 6.23364 30.4903C6.07417 30.2107 5.99362 29.893 6.00039 29.5712V15.9083C5.99563 15.5883 6.0772 15.273 6.23657 14.9955C6.39593 14.718 6.62713 14.4886 6.9059 14.3314L18.3943 8.16399C18.6535 8.03932 18.9408 7.98417 19.2277 8.00392C19.5147 8.02366 19.7915 8.11756 20.0312 8.27656C20.271 8.43556 20.4652 8.65419 20.595 8.91089C20.7248 9.16758 20.7855 9.45356 20.7715 9.74086V35.746C20.7849 36.033 20.7237 36.3185 20.5936 36.5747C20.4636 36.8308 20.269 37.049 20.0294 37.2075C19.7898 37.3661 19.5132 37.4597 19.2266 37.4793C18.94 37.4989 18.6532 37.4437 18.3943 37.3192V37.3266Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5452 33.8262H20.7716"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7734 11.6685H33.9033C34.3386 11.6685 34.756 11.8414 35.0639 12.1492C35.3717 12.4571 35.5448 12.8746 35.5448 13.3099V22.7566"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5447 27.8003V40.7106"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="special-color"
      />
      <path
        d="M29.0896 34.2554H41.9999"
        stroke="#141A21"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="special-color"
      />
    </SvgIconComponent>
  )
}

export const Pins = ({ size, stroke = '#141A21', ...props }) => (
  <SvgIconComponent
    width={48}
    height={48}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    size={size}
  >
    <path
      d="M7.97726 1.33566C6.83747 1.29856 5.7295 1.71513 4.89648 2.49396C4.06345 3.27278 3.5734 4.35026 3.53384 5.48996C3.53384 8.48945 7.97726 14.6667 7.97726 14.6667C7.97726 14.6667 12.4206 8.49195 12.4206 5.48996C12.3809 4.35033 11.8908 3.27299 11.0578 2.49421C10.2248 1.71543 9.11699 1.29878 7.97726 1.33566Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
    />
  </SvgIconComponent>
)

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Audio.propTypes = iconPropTypes
Dataset.propTypes = iconPropTypes
Date.propTypes = iconPropTypes
File.propTypes = iconPropTypes
Folder.propTypes = iconPropTypes
GroupStatic.propTypes = iconPropTypes
GroupFilter.propTypes = iconPropTypes
Link.propTypes = iconPropTypes
Photo.propTypes = iconPropTypes
PlanSimple.propTypes = iconPropTypes
Plan.propTypes = iconPropTypes
ProjectInverted.propTypes = iconPropTypes
Project.propTypes = iconPropTypes
Report.propTypes = iconPropTypes
Sketch.propTypes = iconPropTypes
TaskStack.propTypes = iconPropTypes
Task.propTypes = iconPropTypes
TemplateExcel.propTypes = iconPropTypes
TemplateWord.propTypes = iconPropTypes
AddToReport.propTypes = iconPropTypes
ImportPlan.propTypes = iconPropTypes
NewFolder.propTypes = iconPropTypes
NewProject.propTypes = iconPropTypes
TemplateNew.propTypes = iconPropTypes
Pins.propTypes = iconPropTypes

const iconsEntities = {
  Audio,
  Dataset,
  Date,
  File,
  Folder,
  GroupStatic,
  GroupFilter,
  Link,
  Photo,
  PlanSimple,
  Plan,
  ProjectInverted,
  Project,
  Report,
  Sketch,
  TaskStack,
  Task,
  TemplateExcel,
  TemplateWord,
  AddToReport,
  ImportPlan,
  NewFolder,
  NewProject,
  TemplateNew,
  Pins
}

export default iconsEntities
